import { render, staticRenderFns } from "./RangeFilterModal.vue?vue&type=template&id=488c0ff5"
import script from "./RangeFilterModal.vue?vue&type=script&lang=js"
export * from "./RangeFilterModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports